const MAX_SIZE = 16 * 1024 * 1024 // 16 MB — Meta limit

const buildImageFile = (file: File): File => {
  if (file.name && file.name !== 'image.png' && file.name !== 'blob') return file

  const extension = file.type.split('/')[1] || 'png'
  return new File([file], `screenshot-${Date.now()}.${extension}`, { type: file.type })
}

/**
 * Extrae imagenes de un evento paste (Ctrl+V) del portapapeles, como al
 * pegar una captura de pantalla copiada al clipboard (igual que WhatsApp Web).
 */
export const extractImageFilesFromClipboard = (event: ClipboardEvent): File[] => {
  const items = event.clipboardData?.items
  if (!items) return []

  const files: File[] = []
  for (const item of items) {
    if (item.kind !== 'file' || !item.type.startsWith('image/')) continue
    const file = item.getAsFile()
    if (!file) continue
    if (file.size > MAX_SIZE) continue
    files.push(buildImageFile(file))
  }

  return files
}
